import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateResetPasswordUser = {
  resetPasswordUser: { data: null, loading: false, error: null },
};

export const resetPasswordUser = createAsyncThunk('user/resetPasswordUser', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/users/${data}/password`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerResetPasswordUser = {
  [resetPasswordUser.pending]: (state) => {
    state.resetPasswordUser.loading = true;
    state.resetPasswordUser.error = null;
  },
  [resetPasswordUser.fulfilled]: (state, action) => {
    state.resetPasswordUser.loading = false;
    state.resetPasswordUser.data = true;
    state.resetPasswordUser.error = null;
  },
  [resetPasswordUser.rejected]: (state, action) => {
    state.resetPasswordUser.loading = false;
    state.resetPasswordUser.error = action.payload;
  },
};
